const ITEMS = [
  "LAVADO A DOMICILIO",
  "DETAILING INTERIOR",
  "PULIDO & CERÁMICO",
  "DESCONTAMINADO",
  "SELLADO DE LUZ",
  "LLANTAS COMO NUEVAS",
];

const Star = () => (
  <svg width="11" height="11" viewBox="0 0 10 10" aria-hidden="true" className="shrink-0">
    <path d="M5 0l1.2 3.8L10 5l-3.8 1.2L5 10 3.8 6.2 0 5l3.8-1.2z" fill="#00F2FE" />
  </svg>
);

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="px-6 md:px-10 font-mono text-xs md:text-sm tracking-[0.25em] text-white/70 whitespace-nowrap">
          {t}
        </span>
        <Star />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section className="border-y border-white/10 bg-white/[0.02] py-5 overflow-hidden" data-testid="marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);

export default Marquee;
